import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link,
  Switch,
} from 'react-router-dom';


import Exam from './components/exam/exam';
import Home from './components/home/home';
import RegisterForm from './components/RegisterForm';


import './App.css'


export default function App() {
  return (
    
    <Router>
      {/* <Hero/> */}
      <div>
            <Routes>
            <Route exact path='/evaluacion' element={< Home />}></Route>
            <Route exact path='/evaluacion/home' element={< Home />}></Route>
            <Route exact path='/evaluacion/exam' element={< Exam />}></Route>
            <Route exact path='/evaluacion/form' element={< RegisterForm />}></Route>
            </Routes>


      </div>
     
    </Router>
  );
}
